import { frontendURL } from '../../../helper/URLHelper';
import KnowledgePage from './KnowledgePage.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/knowledge'),
      name: 'knowledge_system',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: KnowledgePage,
    },
  ],
};
